"use client"

import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        "z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-tooltip-content-transform-origin] hidden md:block",
        className
      )}
      {...props}
    />
  </TooltipPrimitive.Portal>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

function MobileTooltip({ children, content, className }: { children: React.ReactNode; content: React.ReactNode; className?: string }) {
  const [open, setOpen] = React.useState(false)

  return (
    <span className={cn("relative inline-flex", className)}>
      <span
        onClick={() => setOpen(!open)}
        onBlur={() => setOpen(false)}
        tabIndex={0}
        role="button"
        aria-expanded={open}
        className="md:hidden"
      >
        {children}
      </span>
      <span className="hidden md:inline">{children}</span>
      {open && (
        <span
          className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md whitespace-nowrap md:hidden"
          data-testid="mobile-tooltip-content"
        >
          {content}
        </span>
      )}
    </span>
  )
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider, MobileTooltip }
